module.exports = __webpack_public_path__ + "img/af.008dc322.svg";